import { Import } from '../../common/import.model';

export class EmployeeExport extends Import {
    protected static _resource = 'transformationManagement/export/:company/employees';
}
